import { VaultMediaType } from '@api'
import { useUnit } from 'effector-react'

import RefreshIcon from '@/assets/icons/icon-refresh.svg'
import SelectAllIcon from '@/assets/icons/icon-select-all.svg'
import { Tooltip } from '@/components/ui/tooltip'
import {
  $canSelectAllMedia,
  $isRefetchAvailable,
  $selectedMediaType,
  refetchVaultMedias,
  selectAllMediaFx,
  setSelectedMediaType,
} from '@/models/vault/medias'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'
import { classNames } from '@/utils/helpers.ts'

const typeToLabel: Record<
  Exclude<VaultMediaType, VaultMediaType.UNKNOWN>,
  string
> = {
  [VaultMediaType.ALL]: 'All',
  [VaultMediaType.VIDEO]: 'Video',
  [VaultMediaType.PHOTO]: 'Photo',
  [VaultMediaType.GIF]: 'GIF',
  [VaultMediaType.AUDIO]: 'Audio',
}

export const VaultTypeSelection = () => {
  const selectedType = useUnit($selectedMediaType)
  const canSelectAllMedia = useUnit($canSelectAllMedia)
  const isRefetchAvailable = useUnit($isRefetchAvailable)

  return (
    <div className="mb-3 mt-2 flex flex-wrap items-center gap-1 px-3">
      {Object.entries(typeToLabel).map(([key, value]) => (
        <div
          key={key}
          // @ts-ignore
          onClick={() => setSelectedMediaType(key)}
          className={classNames(
            'text-text-default mr-2 cursor-pointer rounded-[100px] px-3 py-1 text-sm font-medium transition duration-200 last:mr-0',
            {
              'bg-primary-500 dark:bg-primary-500 text-white':
                selectedType === key,
              'bg-secondary-50 hover:bg-secondary-200 dark:bg-secondary-600 dark:hover:bg-primary-800':
                selectedType !== key,
            },
          )}
        >
          {value}
        </div>
      ))}
      <div className="flex items-center ml-auto gap-2">
        <Tooltip
          content={canSelectAllMedia.message}
          asChild
        >
          <IconButton
            onClick={selectAllMediaFx}
            className="w-5 h-5 text-text-default"
            icon={SelectAllIcon}
            disabled={!canSelectAllMedia.value}
          />
        </Tooltip>

        <Tooltip
          content="Refresh media"
          disabled={!isRefetchAvailable}
          asChild
        >
          <IconButton
            onClick={refetchVaultMedias}
            className="text-text-default w-5 h-5"
            disabled={!isRefetchAvailable}
            icon={RefreshIcon}
          />
        </Tooltip>
      </div>
    </div>
  )
}
